export const intensityLevels = [
  { min: 0.4, max: 5.0, color: '#dceeffff', label: 'Leve (0,4 – 5,0 mm/h)' },

  {
    min: 5.1,
    max: 25.0,
    color: '#B3D9FF',
    label: 'Moderada (5,1 – 25,0 mm/h)',
  },
  { min: 25.1, max: 50.0, color: '#80BFFF', label: 'Forte (25,1 – 50,0 mm/h)' },
  {
    min: 50.1,
    max: Infinity,
    color: '#4D94FF',
    label: 'Muito Forte (> 50,0 mm/h)',
  },
];

export function getRowColor(precipitationHour: number): string {
  const level = intensityLevels.find(
    ({ min, max }) => precipitationHour >= min && precipitationHour <= max,
  );
  return level?.color ?? '#fafafae1';
}